module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress-bar nprogress-bar",
    class: ( _obj = {
      error: _vm.isError
    }, _obj[_vm.$style.root] = true, _obj )
  })
  var _obj;
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-739f83b8"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/progress-bar/ProgressBar.vue
// module id = 946
// module chunks = 1